<template>
  <label
    class="input"
    :class="{
      'input--filled': !!value,
      'input--error': !!error,
      'input--icon-left': iconPosition === 'left',
      'input--icon-right': iconPosition === 'right',
      'input--disabled': disabled,
    }"
  >
    <span class="input__title" v-if="title">{{ title }}</span>
    <span class="input__container">
      <button class="input__action" type="button" v-if="iconPosition" @click="$emit('action')">
        <slot name="icon">
          <IconComponent name="search-normal-1" class="icon--thick" />
        </slot>
      </button>
      <input
        :type="type"
        v-mask="mask"
        :placeholder="placeholder"
        class="input__field"
        :min="min"
        :max="max"
        ref="input"
        :value="value"
        @keydown="handleKeyDown"
        @input="handleInput"
        @focus="focus"
        @blur="$emit('blur', $event)"
        :disabled="disabled"
      />
    </span>
    <span v-if="subtitle" class="input__subtitle">{{ subtitle }}</span>
    <span v-if="error" class="input__error">{{ error }}</span>
  </label>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import { VueMaskDirective } from "v-mask";

export default {
  name: "InputComponent",
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    mask: {
      type: String,
    },
    type: {
      type: String,
      default() {
        return "text";
      },
    },
    numbersOnly: {
      type: Boolean,
    },
    placeholder: {
      type: [String, Number],
    },
    min: Number,
    max: Number,
    value: {
      type: [String, Number],
    },
    error: {
      type: String,
    },
    iconPosition: {
      type: String,
      validator(value) {
        return value === "left" || value === "right";
      },
    },
    disabled: {
      type: Boolean,
    },
    isPhone: Boolean,
    autofocus: Boolean,
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.input.focus();
    }
  },
  methods: {
    focus(e) {
      if (!this.value && this.isPhone) {
        this.$emit("input", " ");
      }
      this.$emit("focus", e);
    },
    handleInput(e) {
      let value = e.target.value;
      if (this.type === "number") {
        //   if (value < this.min) {
        //     this.$refs.input.value = this.min.toString();
        //     this.$emit("input", this.min);
        //   } else if (value > this.max) {
        //     this.$refs.input.value = this.max.toString();
        //     this.$emit("input", this.max);
        //   } else {
        //     this.$refs.input.value = value.toString();
        //     this.$emit("input", value);
        //   }
        this.$emit("input", value);
      } else {
        this.$refs.input.value = value.toString();
        if (this.numbersOnly) {
          this.$refs.input.value = value.replace(/[^0-9]/g, "");
          this.$emit("input", value.replace(/[^0-9]/g, ""));
        } else {
          this.$emit("input", value);
        }
      }
    },
    handleKeyDown(e) {
      if (e.keyCode === 13) {
        this.$emit("enter");
      }
    },
  },
  components: { IconComponent },
  directives: {
    mask: VueMaskDirective,
  },
};
</script>

<style lang="stylus">
.input {
  display inline-flex
  flex-direction column
  gap 5px

  &__container {
    display flex
    position relative
    background: var(--white);
    border: 1px solid var(--main-color-75);
    box-sizing: border-box;
    border-radius: var(--main_radius);
    height 50px
    transition var(--transition)
    overflow hidden

    &:hover {
      border-color var(--main-color-75)
    }
  }

  &:focus-within {
    & ^[0]__container {
      border-color var(--dark)
    }

    & .icon svg path {
      stroke var(--dark)
      opacity: 1;
    }
  }

  &--filled:not(:focus-within) {
    //& ^[0]__container {
    //  border-color var(--main-color-75)
    //}

    & .icon svg path {
      stroke var(--main-color)
      opacity: 0.5;
    }
  }

  &--error& {
    & ^[0]__container {
      border-color var(--red)
    }

    & .icon svg path {
      stroke var(--red)
    }

    &__field {
      color: var(--red);

      &::placeholder {
        color: var(--red);
      }
    }
  }

  &--focused {
    & ^[0]__container {
      border-color var(--dark)
    }
  }

  &--error {
    & ^[0]__container {
      border-color var(--red)
    }
  }

  &--disabled {
    & ^[0]__container {
      background var(--gray)
    }
  }

  &--icon-left &__action {
    absolute left top
  }

  &--icon-left &__field {
    padding 15px 15px 15px 50px
  }

  &--icon-right &__action {
    absolute right top
  }

  &--icon-right &__field {
    padding 15px 50px 15px 15px
  }

  &__title {
    font-size: 0.75em
    line-height: 13px;
    color: var(--body-color);
    opacity: 0.5;
    white-space pre-line
  }

  &__subtitle {
    font-weight: normal;
    font-size: 0.75em;
    line-height: 20px;
    color: var(--main-color);
    opacity .5
  }

  &__error {
    font-weight: normal;
    font-size: 0.75em;
    line-height: 20px;
    color: var(--red);
  }

  &__action {
    background none
    border none
    height 100%
    display inline-flex
    align-items center
    padding 15px
    cursor pointer
  }

  &__field {
    border none
    background none
    width 100%
    height 100%
    padding 15px
    outline none
    font-weight: normal;
    font-size: 0.875em;
    color: var(--main-color);

    &::placeholder {
      font-weight: normal;
      color #AEAEAF
      opacity .5
    }
  }

  .icon {
    width 20px
    height 20px

    svg path {
      transition var(--transition)
      stroke var(--main-gray)
      opacity: 0.3;
    }
  }
}
</style>
